module.exports = __webpack_public_path__ + "static/media/ticket.9d783958.svg";